module.exports = __webpack_public_path__ + "img/review.98be5d0.jpg";